export const categories = [
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'dianying', name: '电影', icon: 'ri-film-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-mic-line' },
  { slug: 'dongman', name: '动漫', icon: 'ri-rocket-line' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-camera-line' },
  { slug: 'hanju', name: '韩剧', icon: 'ri-heart-line' },
  { slug: 'meiju', name: '美剧', icon: 'ri-flag-line' },
  { slug: 'riju', name: '日剧', icon: 'ri-sun-line' },
];

export const allTvSeries = [
  {
    id: 1,
    title: '繁花',
    category: 'dianshiju',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20Blossoms%20Shanghai%20poster%20style%20with%20elegant%20cityscape%20and%20vintage%201990s%20aesthetic%2C%20warm%20golden%20tones%2C%20cinematic%20film%20poster%20design%20with%20Chinese%20title%2C%20dramatic%20lighting&width=400&height=560&seq=tv-fanhua-01&orientation=portrait',
    description: '九十年代的上海处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的努力，从平凡青年成长为商界后起之秀。在沪上弄潮儿女中，他经历过金碧辉煌，也经历过细水长流，书写了一段传奇故事。',
    rating: 9.3,
    episodes: 30,
    year: 2023,
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    director: '王家卫',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    updateInfo: '全30集',
  },
  {
    id: 2,
    title: '狂飙',
    category: 'dianshiju',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20The%20Knockout%20poster%20with%20intense%20dark%20atmosphere%2C%20police%20and%20gangster%20theme%2C%20cinematic%20lighting%2C%20dramatic%20film%20poster%20design%2C%20Chinese%20title&width=400&height=560&seq=tv-kuangbiao-02&orientation=portrait',
    description: '2000年，意气风发的刑警安欣与备受欺负的鱼贩高启强相识，两人从陌生到熟悉，再到分道扬镳。随着高启强逐渐偏离正途，安欣意识到在京海市社会发展的背后，正是以高家兄弟为首的黑恶势力暗流汹涌。',
    rating: 9.5,
    episodes: 39,
    year: 2023,
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    director: '徐纪周',
    region: '中国大陆',
    isHot: true,
    isNew: false,
    updateInfo: '全39集',
  },
  {
    id: 3,
    title: '庆余年第二季',
    category: 'dianshiju',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20Joy%20of%20Life%20Season%202%20poster%20with%20ancient%20Chinese%20palace%20and%20martial%20arts%20elements%2C%20epic%20cinematic%20style%2C%20dramatic%20composition%2C%20rich%20warm%20colors&width=400&height=560&seq=tv-qingyunian-03&orientation=portrait',
    description: '范闲在经历了第一季的生死考验后，再次回到京都。面对更加复杂的朝堂局势和各方势力的明争暗斗，他必须运用智慧与勇气，在权谋与江湖之间走出一条属于自己的道路。',
    rating: 8.9,
    episodes: 36,
    year: 2024,
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    director: '孙皓',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    updateInfo: '更新至36集',
  },
  {
    id: 4,
    title: '长相思',
    category: 'dianshiju',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20Lost%20You%20Forever%20poster%20with%20ethereal%20ancient%20Chinese%20aesthetic%2C%20flowing%20fabrics%2C%20mythical%20atmosphere%2C%20soft%20warm%20lighting%2C%20cinematic%20film%20poster&width=400&height=560&seq=tv-zhangxiangsi-04&orientation=portrait',
    description: '上古时期，人神妖混居。流落大荒的高辛王姬玖瑶历经百年颠沛，失去了身份和容貌，在清水镇落脚，成为了悬壶济世的医师玟小六。命运让她与表哥玱玹、青丘公子涂山璟、九头妖相柳等人相遇。',
    rating: 8.7,
    episodes: 39,
    year: 2023,
    actors: ['杨紫', '张晚意', '邓为', '檀健次'],
    director: '秦榛',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    updateInfo: '全39集',
  },
  {
    id: 5,
    title: '黑暗荣耀',
    category: 'hanju',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20revenge%20drama%20The%20Glory%20poster%20with%20dark%20moody%20atmosphere%2C%20mysterious%20woman%20silhouette%2C%20elegant%20cinematic%20style%2C%20dramatic%20shadow%20and%20light%2C%20film%20poster%20design&width=400&height=560&seq=tv-heianrongyao-05&orientation=portrait',
    description: '梦想成为建筑师的女主文东恩，在高中时期因遭受校园暴力而退学。多年后，她成为了加害者孩子的班主任，一场精心策划的复仇计划就此展开，向那些曾经伤害过她的人讨回公道。',
    rating: 9.1,
    episodes: 16,
    year: 2023,
    actors: ['宋慧乔', '李到晛', '林智妍', '郑成日'],
    director: '安吉镐',
    region: '韩国',
    isHot: false,
    isNew: false,
    updateInfo: '全16集',
  },
  {
    id: 6,
    title: '三体',
    category: 'dianshiju',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20Three%20Body%20poster%20with%20cosmic%20and%20futuristic%20elements%2C%20mysterious%20universe%20theme%2C%20scientific%20aesthetic%2C%20dramatic%20cinematic%20film%20poster&width=400&height=560&seq=tv-santi-06&orientation=portrait',
    description: '纳米科学家汪淼被警官史强带到联合作战中心，潜入名为"科学边界"的组织协助调查。在调查过程中，汪淼接触到一个名为"三体"的VR游戏，一个关于外星文明的惊天秘密逐渐浮出水面。',
    rating: 8.4,
    episodes: 30,
    year: 2023,
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    director: '杨磊',
    region: '中国大陆',
    isHot: true,
    isNew: false,
    updateInfo: '全30集',
  },
  {
    id: 7,
    title: '漫长的季节',
    category: 'dianshiju',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20drama%20The%20Long%20Season%20poster%20with%20nostalgic%20northeastern%20China%20industrial%20town%20atmosphere%2C%20vintage%201990s%20aesthetic%2C%20melancholic%20cinematic%20style&width=400&height=560&seq=tv-manchang-07&orientation=portrait',
    description: '小城桦林，出租车司机王响遭遇人生巨变。一宗跨越二十年、横跨两个时代的碎尸悬案，将三个老人的命运交织在一起。他们踏上了寻找真相的旅程，在追寻中回望各自的人生。',
    rating: 9.4,
    episodes: 12,
    year: 2023,
    actors: ['范伟', '秦昊', '陈明昊', '李庚希'],
    director: '辛爽',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    updateInfo: '全12集',
  },
  {
    id: 8,
    title: '莲花楼',
    category: 'dianshiju',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20mystery%20drama%20Mysterious%20Lotus%20Casebook%20poster%20with%20ancient%20Chinese%20architecture%20and%20swordsman%2C%20elegant%20wuxia%20style%2C%20warm%20golden%20lighting&width=400&height=560&seq=tv-lianhualou-08&orientation=portrait',
    description: '闻名武林的四顾门门主李相夷在一次大战后身受重伤，从此退隐江湖成为淡泊名利的游医李莲花。十年后，他遇到热血少年方多病和旧识笛飞声，三人一同破解了一系列江湖奇案。',
    rating: 8.8,
    episodes: 40,
    year: 2023,
    actors: ['成毅', '曾舜晞', '肖顺尧', '陈都灵'],
    director: '郭虎',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    updateInfo: '全40集',
  },
  {
    id: 9,
    title: '鱿鱼游戏第二季',
    category: 'hanju',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20Squid%20Game%20Season%202%20poster%20with%20iconic%20geometric%20shapes%20and%20vibrant%20colors%2C%20mysterious%20game%20theme%2C%20dramatic%20cinematic%20film%20poster%20design&width=400&height=560&seq=tv-youyuyouxi-09&orientation=portrait',
    description: '成奇勋在赢得456亿韩元后，本可以远走高飞。但他决定回到这个神秘组织的游戏中，找出幕后黑手。新一轮的生死游戏再次开启，这一次的规则更加残酷，参赛者们为了巨额的奖金赌上一切。',
    rating: 8.2,
    episodes: 10,
    year: 2024,
    actors: ['李政宰', '李秉宪', '孔刘', '魏河俊'],
    director: '黄东赫',
    region: '韩国',
    isHot: true,
    isNew: true,
    updateInfo: '全10集',
  },
  {
    id: 10,
    title: '阿凡达：水之道',
    category: 'dianying',
    coverImage: 'https://readdy.ai/api/search-image?query=Avatar%20The%20Way%20of%20Water%20movie%20poster%20with%20blue%20alien%20characters%20and%20ocean%20theme%2C%20epic%20cinematic%20underwater%20world%2C%20fantastical%20creatures%2C%20dramatic%20film%20poster&width=400&height=560&seq=tv-afanda-10&orientation=portrait',
    description: '杰克·萨利在潘多拉星球上与奈蒂莉组建了家庭，过上了平静的生活。然而，当人类再次入侵潘多拉时，为了保护家人，杰克不得不带领族人展开新的战斗，前往礁人族寻求庇护。',
    rating: 8.0,
    episodes: 1,
    year: 2022,
    actors: ['萨姆·沃辛顿', '佐伊·索尔达娜', '西格妮·韦弗'],
    director: '詹姆斯·卡梅隆',
    region: '美国',
    isHot: false,
    isNew: false,
    updateInfo: 'HD高清',
  },
  {
    id: 11,
    title: '奥本海默',
    category: 'dianying',
    coverImage: 'https://readdy.ai/api/search-image?query=Oppenheimer%20movie%20poster%20with%20nuclear%20explosion%20and%20intense%20portrait%20of%20scientist%2C%20dramatic%20black%20and%20orange%20color%20scheme%2C%20cinematic%20historical%20film%20poster&width=400&height=560&seq=tv-aobenheimer-11&orientation=portrait',
    description: '聚焦美国"原子弹之父"罗伯特·奥本海默在曼哈顿计划中的角色，以及他在研制出世界上第一颗原子弹后所面临的道德困境和政治迫害。一部关于科学、权力和良知的史诗传记片。',
    rating: 8.8,
    episodes: 1,
    year: 2023,
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    director: '克里斯托弗·诺兰',
    region: '美国',
    isHot: false,
    isNew: false,
    updateInfo: 'HD高清',
  },
  {
    id: 12,
    title: '向往的生活',
    category: 'zongyi',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20Back%20to%20Field%20poster%20with%20rural%20countryside%20and%20warm%20family%20atmosphere%2C%20green%20nature%2C%20cozy%20farmhouse%2C%20bright%20and%20cheerful%20style&width=400&height=560&seq=tv-xiangwang-12&orientation=portrait',
    description: '在远离城市喧嚣的蘑菇屋，何炅和黄磊带着年轻的嘉宾们一起耕种、做饭、聊天，体验田园生活的悠闲与惬意。每一期都有不同的飞行嘉宾来到蘑菇屋，带来欢笑与感动。',
    rating: 8.5,
    episodes: 14,
    year: 2023,
    actors: ['何炅', '黄磊', '张艺兴', '彭昱畅'],
    director: '王征宇',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    updateInfo: '全14期',
  },
  {
    id: 13,
    title: '鬼灭之刃 锻刀村篇',
    category: 'dongman',
    coverImage: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20Swordsmith%20Village%20Arc%20anime%20poster%20with%20Japanese%20animation%20style%2C%20dynamic%20action%20scene%2C%20vibrant%20colors%2C%20beautiful%20character%20design%2C%20dramatic%20composition&width=400&height=560&seq=tv-guimie-13&orientation=portrait',
    description: '炭治郎前往锻刀村修复他的日轮刀。在那里，他遇到了恋柱甘露寺蜜璃和霞柱时透无一郎。然而，上弦之鬼的袭击让锻刀村陷入了前所未有的危机之中，激烈的战斗一触即发。',
    rating: 9.0,
    episodes: 11,
    year: 2023,
    actors: ['花江夏树', '鬼头明里', '下野纮', '松冈祯丞'],
    director: '外崎春雄',
    region: '日本',
    isHot: false,
    isNew: false,
    updateInfo: '全11集',
  },
  {
    id: 14,
    title: '地球脉动 第三季',
    category: 'jilupian',
    coverImage: 'https://readdy.ai/api/search-image?query=Planet%20Earth%20III%20documentary%20poster%20with%20stunning%20wildlife%20and%20nature%20photography%2C%20diverse%20ecosystems%2C%20breathtaking%20landscapes%2C%20epic%20cinematic%20style&width=400&height=560&seq=tv-maiodong-14&orientation=portrait',
    description: 'BBC纪录片团队历时五年，走遍全球六大洲的43个国家和地区，用最先进的拍摄技术记录下地球各个角落的生命奇迹。从深海到沙漠，从极地到雨林，展现大自然最壮丽的画面。',
    rating: 9.8,
    episodes: 8,
    year: 2023,
    actors: ['大卫·爱登堡'],
    director: 'BBC自然历史部',
    region: '英国',
    isHot: false,
    isNew: false,
    updateInfo: '全8集',
  },
  {
    id: 15,
    title: '新闻女王',
    category: 'dianshiju',
    coverImage: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20newsroom%20drama%20The%20Queen%20of%20News%20poster%20with%20modern%20office%20setting%2C%20professional%20woman%20in%20suit%2C%20media%20industry%20theme%2C%20cinematic%20dramatic%20lighting&width=400&height=560&seq=tv-xinwennvwang-15&orientation=portrait',
    description: '在收视率至上的香港新闻界，资深主播文慧心凭借过人的能力和手腕，在职场中不断攀爬。然而当新人主播许诗晴出现，一场关于权力、理想与道德的新闻大战就此展开。',
    rating: 8.1,
    episodes: 26,
    year: 2023,
    actors: ['佘诗曼', '马国明', '李施嬅', '高海宁'],
    director: '钟澍佳',
    region: '中国香港',
    isHot: false,
    isNew: true,
    updateInfo: '全26集',
  },
  {
    id: 16,
    title: '最后生还者',
    category: 'meiju',
    coverImage: 'https://readdy.ai/api/search-image?query=The%20Last%20of%20Us%20HBO%20drama%20poster%20with%20post-apocalyptic%20theme%2C%20survivors%20in%20ruined%20city%2C%20emotional%20father-daughter%20bond%2C%20cinematic%20dramatic%20lighting&width=400&height=560&seq=tv-thelastofus-16&orientation=portrait',
    description: '在现代文明被摧毁的二十年后，坚强的幸存者乔尔受雇将14岁的女孩艾莉偷偷带出一个严酷的隔离区。起初只是一份简单的工作，但很快就变成了一段残酷而令人心碎的旅程。',
    rating: 9.0,
    episodes: 9,
    year: 2023,
    actors: ['佩德罗·帕斯卡', '贝拉·拉姆齐', '安娜·托芙'],
    director: '克雷格·麦辛',
    region: '美国',
    isHot: false,
    isNew: false,
    updateInfo: '全9集',
  },
];